import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import CardForm from "./CardForm";
import BankForm from "./BankForm";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const PaymentBox = ({ token }) => {
  const [key, setKey] = useState("pills-card");
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(true)
  }, [])

  return (
    <section className="payment-box py-5">
      <div className="container">
        <div className="custom-card p-4">
          <div className="d-flex flex-column flex-lg-row align-items-lg-center align-items-center justify-content-between mb-4">
            <figure className="mb-0">
              <img src="/images/instamed_header_logo_hires.png" className="w-100" alt="" />
            </figure>
            <h5 className="custom-card-header">Update Payment Method</h5>
          </div>
          <div className="custom-card-content">
            <Tabs
              defaultActiveKey="pills-card"
              id="pills-tab"
              className="nav nav-pills mb-3"
              onSelect={(k) => setKey(k)}
              transition={false}
            >
              <Tab
                eventKey="pills-card"
                title="Credit / Debit Card"
                className="nav-link"
                id="pills-card-tab"
              >
                <CardForm
                  token={token}
                />
              </Tab>
              <Tab
                eventKey="pills-bank"
                title="Bank Account"
                className="nav-link"
                id="pills-bank-tab"
                >
                <BankForm
                  token={token}
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      <Modal show={show} centered={true} size="lg" onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="h5 mb-0">Information</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="h6 mb-0">If you choose EFT (checking account), you'll be awarded a one-time $100 account credit!</div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default PaymentBox;
